<script>
import $ from "jquery";
// eslint-disable-next-line no-unused-vars
import turn from "../../static/turn";

import MenuBar from "./components/MenuBar.vue";

import { getBook } from "@/api/partyTop";
import { imgPath } from "@/utils/filters";

export default {
  components: { MenuBar },
  data() {
    return {
      village: localStorage.getItem("currentCommunity") || "",
      value: "",
      bookData: [],
      currentPage: 1,
      sliderValue: 0,
    };
  },
  watch: {
    currentPage(newVal) {
      const percentage = newVal / this.bookData.length;
      this.$refs.range.style.backgroundSize = `${percentage} 100%`;
      this.sliderValue = newVal === 1 ? 0 : (360 * percentage).toFixed(0);
    },
  },
  mounted() {
    // this.initBook()
    this.initPageData();
  },
  methods: {
    imgPath,
    initBook() {
      let self = this;
      $("#flipbook").turn("center");
      $("#flipbook").turn("page");
      this.$nextTick(() => {
        $("#flipbook").turn({
          display: "double",
          elevation: 50,
          duration: 1000,
          gradients: true,
          autoCenter: true,
          acceleration: true,
          page: self.currentPage,
          width: 1152,
          height: 752,
          when: {
            turning: function (event, page, view) {
              // console.log('turning', page, view) // page 和 view 显示的是当前展示的页号
              self.currentPage = view[0] === 0 ? 1 : view[0];
            },
            turned: function () {
              // 当前页
              // console.log('Current view: ', $(this).turn('view'))
              // self.currentPage = $(this).turn('view')[0] === 0 ? 1 : $(this).turn('view')[0]
              // 总页数
              // console.log('#flipbook has ' + $('#flipbook').turn('pages') + ' pages')
              // $("#flipbook").turn("hasPage", 10);
              // $("#flipbook").turn("pages", 5);
            },
          },
        });
      });
    },

    /* back to the first page */
    backHome() {
      $("#flipbook").turn("page", 1);
    },
    onChange() {
      let value = this.$refs.range.value;
      const percentage = ((value / 360) * 100).toFixed(0) + "%";
      const percentageNum = (value / 360).toFixed(2);
      this.$refs.range.style.backgroundSize = `${percentage} 100%`;

      const pager = (this.bookData.length * percentageNum).toFixed(0);
      const toPager = Number(pager) === 0 ? 1 : pager;
      $("#flipbook").turn("page", toPager);
    },
    changePage(direction) {
      // const prePage = this.currentPage === 2 ? 1 : 2
      // this.currentPage = direction === 'pre' ? this.currentPage - prePage : this.currentPage + 2
      // $('#flipbook').turn('page', this.currentPage)
      if (
        (this.currentPage === 1 && direction === "pre") ||
        (this.currentPage === this.bookData.length && direction === "next")
      )
        return;
      $("#flipbook").turn(direction === "pre" ? "previous" : "next");
    },

    initPageData() {
      getBook({ village: this.village }).then((res) => {
        if (res.code === 0) {
          this.bookData = res.msg || [];
          this.initBook();
        }
      });
    },
  },
};
</script>

<template>
  <div class="page-content">
    <el-image
      class="hy-logo"
      :src="require('imgs/partyTop/hy-logo.png')"
      alt="hy-logo"
    />

    <div class="book-container">
      <div
        v-if="currentPage !== 1 && currentPage !== bookData.length"
        class="depth"
      />
      <div
        v-if="currentPage !== 1 && currentPage !== bookData.length"
        class="depth-right"
      />
      <div
        id="flipbook"
        class="flipbook"
        :class="{
          'flipbook-left': currentPage === 1,
          'shadow-flipbook':
            currentPage !== 1 && currentPage !== bookData.length,
        }"
      >
        <div
          v-for="(v, i) in bookData"
          :key="`test_${i}`"
          :class="`book-item-${i}`"
        >
          <div
            class="img-box"
            :class="{
              'odd-img': i % 2 !== 0 && i + 1 !== bookData.length,
              'even-img': i % 2 === 0 && i + 1 !== 1,
            }"
            :style="{ background: `url(${imgPath(v.img)}) no-repeat center` }"
          >
            <!-- <footer
              v-if="i !== 0 && i !== bookData.length - 1"
              class="current-page"
            >
              <div v-if="i % 2 == 0" class="even-numbers">{{ i }}</div>
              <div v-else class="odd-number">{{ i }}</div>
            </footer> -->
          </div>
        </div>
      </div>
    </div>

    <div class="slider-progress">
      <input
        ref="range"
        type="range"
        min="0"
        max="360"
        :value="sliderValue"
        @input="onChange"
        @change="onChange"
      />
    </div>

    <div class="pager-container">
      <p class="pager-container-item" @click="changePage('pre')">上一页</p>
      <p class="pager-container-item" @click="changePage('next')">下一页</p>
    </div>

    <menu-bar />
  </div>
</template>

<style lang="scss">
.page-content {
  .shadow {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px !important;
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  width: 100%;
  min-height: 100vh;
  background: url("~imgs/partyTop/book-page-bg.webp") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  .hy-logo {
    position: absolute;
    top: 26px;
    left: 26px;
    width: 87px;
    height: 50px;
  }
}

.book-container {
  position: relative;
  margin-top: 124px;
  .depth {
    background-image: url("~imgs/partyTop/pages-depth.png");
    background-size: 100% 100%;
    position: absolute;
    left: -18px;
    top: -7px;
    width: 38px;
    height: 767px;
    // left: -18PX;
    // top: -7px;
    // width: 38PX;
    // height: 767PX;
  }
  .depth-right {
    background-image: url("~imgs/partyTop/pages-depth.png");
    background-size: 100% 100%;
    position: absolute;
    right: -18px;
    top: -7px;
    width: 38px;
    height: 767px;
    // right: -18PX;
    // top: -7px;
    // width: 38PX;
    // height: 767PX;
  }
}
.pager-container {
  display: flex;
  column-gap: 10px;
  margin-top: 30px;
  .pager-container-item {
    width: 113px;
    height: 40px;
    background: url("~imgs/partyTop/prev.png") no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #a3000d;
    cursor: pointer;
  }
  .pager-container-item:nth-child(2) {
    background: url("~imgs/partyTop/next.png") no-repeat center;
    background-size: 100% 100%;
    color: #fefefe;
  }
}

.img-box {
  background-size: 100% 100% !important;
  width: 100%;
  height: 752px;
  // height: 752PX;
  position: relative;
}
.odd-img {
  box-shadow: rgba(0, 0, 0, 0.35) -50px 0 46px -28px inset;
}
.even-img {
  box-shadow: rgba(0, 0, 0, 0.35) 30px 0 36px -28px inset;
}

.current-page {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 14px;
}
#flipbook {
  /* !!! 禁止删除!important 覆盖默认行内样式以自适应屏幕 */
  width: 1152px !important;
  height: 752px !important;
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.flipbook {
  // transition: all linear .2s;
  margin-left: 0 !important;
}
.flipbook-left {
  // transition: all linear .2s;
  // margin-left: -600px !important;
  transform: translateX(-300px) !important;
}
.shadow-flipbook {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: #fff;
}

.even-numbers {
  width: 30px;
  height: 30px;
  background: #ffcc66;
  color: #fff;
  right: 0;
  position: absolute;
  bottom: 0px;
  line-height: 30px;
  text-align: center;
}
.odd-number {
  position: absolute;
  bottom: 0px;
  width: 30px;
  height: 30px;
  background: #cc00ff;
  color: #fff;
  line-height: 30px;
  text-align: center;
}
#flipbook.shadow {
  -webkit-box-shadow: 0 4px 10px #666;
  -moz-box-shadow: 0 4px 10px #666;
  -ms-box-shadow: 0 4px 10px #666;
  -o-box-shadow: 0 4px 10px #666;
  box-shadow: 0 4px 10px #666;
}

#flipbook .turn-page {
  background-color: #ccc;
  background-size: 100% 100%;
}
.bookmark {
  margin-left: 633px;
  font-size: 20px;
  writing-mode: tb-rl;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 47px;
}
.item:nth-child(2n) {
  background: #ccc;
  width: 45px;
  height: 150px;
}

.slider-progress {
  margin: 20px 0 0 15px;
  // 控件
  input[type="range"] {
    outline: none;
    -webkit-appearance: none; /*清除系统默认样式*/
    width: 900px !important;
    background: -webkit-linear-gradient(#fffcbf, #fffcbf) no-repeat, #fffcbf; /*背景颜色，俩个颜色分别对应上下*/
    background-size: 0% 100%; /*设置左右宽度比例，这里可以设置为拖动条属性*/
    height: 9px;
    border-radius: 5px;
  }
  /*拖动块的样式*/
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none; /*清除系统默认样式*/
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background: #37be51; /*拖动块背景*/
    border: 2px solid #fff;
    cursor: pointer;
  }
}

.current-page2 {
  font-size: 20px;
  margin-top: 10px;
}
.tool {
  display: flex;
  column-gap: 10px;
  font-size: 20px;
  cursor: pointer;
  margin-top: 10px;
}
</style>
